import React from 'react';

const FwTenantIcon = ({ color = 'currentColor', size = '16px' }) => {
  return <i className='fas fa-address-book' style={{ color, fontSize: size }}></i>;
};

export default FwTenantIcon;
